<template>
  <div class="sidebar responsive sidebar-hidden" v-if="hide">
    <a id="profile" class="hide-profile-button" @click="toggleHide">&#8594;</a>
  </div>
  <div class="sidebar left fixed responsive xlarge-down no-transition" id="profile" v-else>
    <div class="fixed-container">
      <button class="show-profile-button" @click="toggleHide">&#8592;</button>

      <!-- Profile -->
      <div class="sidebar-profile-intro">
        <a href="javascript:;" @click="$emit('switchKundeView', true)">
        <span class="avatar large icon profile">
          <span class="statusicon inactive" v-if="kunde.Sperret === 'T'"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
            xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
          <span class="statusicon active" v-else><svg width="16px" height="16px" viewBox="0 0 16 16"><use
            xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
          <svg width="80px" height="80px" viewBox="0 0 80 80"><use
            xlink:href="/static/sprites.svg#user-avatar-glyph-large"></use></svg>
        </span>
        </a>
        <h4><a href="javascript:;" @click="$emit('switchKundeView', true)">{{kunde.Bedrift ? kunde.FirmaNavn : kunde.full_name}}</a></h4>
        <span class="profile-user-title">Kundenr: {{kunde.Kundenr}} <span v-if="kunde.Sperret === 'T'" style="color: red;"><br>Sperret</span></span>
      </div>

      <!-- Tabs -->
      <div class="tabs fluid" id="sidebar-tabs">
        <ul>
          <li v-for="(tabItem, key) in tabs" :key="key" :class="{'active': key === selectedTab}">
            <a href="javascript:;" @click="tab(key)">{{ tabItem.name }}<span
              v-if="key === 'notater' && totalCount > 0"> ({{totalCount}})</span></a>
          </li>
        </ul>
      </div>

      <!-- Tab Content -->
      <component v-bind:is="selectedTabComponent" v-bind="{kunde: kunde}" v-if="selectedTabComponent"></component>
      <!-- End Tab Content -->
    </div>

    <a href="javascript:;" @click="hideProfileSidebar()" class="sidebar-overlay"></a>
  </div>
</template>

<script>
import TabProfile from './KundeCardSidebarTabProfile'
import TabHistorikk from './KundeCardSidebarTabHistorikk'
import TabNotater from './KundeCardSidebarTabNotater'
import {mapGetters} from 'vuex'

export default {
  name: 'KundeCardSidebar',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hide: false,
      tabs: {
        'profile': {name: 'Profil', component: TabProfile},
        'logg': {name: 'Historikk', component: TabHistorikk},
        'notater': {name: 'Kundenotater', component: TabNotater}
      },
      selectedTab: '',
      selectedTabComponent: null,
      loadMoreBusy: false
    }
  },
  created () {
    if (localStorage.hideCustomersidebar != null) {
      this.hide = Boolean.apply(localStorage.hideCustomersidebar)
    }
  },
  mounted () {
    // Load KundeCardProfile Tab from localstorage or default
    if (localStorage.hideCustomersidebar != null) {
      this.hide = JSON.parse(localStorage.hideCustomersidebar)
    }
    let tab = 'profile' // localStorage.kcp_tab || 'profile'

    // Load kunde notater
    this.$store.dispatch('kundenotat/load', this.kunde.Kundenr)

    // Load kunde history
    this.$store.dispatch('kundehistory/load', this.kunde.Kundenr)

    // Set correct tab
    this.tab(tab)
  },
  computed: {
    ...mapGetters('kundenotat', [ 'totalCount' ])
  },
  methods: {
    toggleHide: function () {
      this.hide = !this.hide
      localStorage.hideCustomersidebar = this.hide
      setTimeout(function () {
        window.jQuery('table.fixed').addClass('sticky')
        window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
        window.jQuery(window).resize(function () {})
      }, 500)
    },
    tab: function (tab) {
      if (this.tabs.hasOwnProperty(tab)) {
        // Save to localstorage - to remember
        // localStorage.kcp_tab = tab

        this.selectedTab = tab
        this.selectedTabComponent = this.tabs[tab].component
      }
    },
    hideProfileSidebar: function () {
      this.$helpers.toggleSidebar('profile')
    }
  }
}
</script>

<style scoped>
  .sidebar-hidden {
    width: 25px;
    display: none;
  }
  /**
   * Add this to the top sidebar - if no sider should be on edit page
   *
   * :class="{'sidebar-removed': $route.hash === '#edit' }"
   * And remove the created / beforeDestroy in KundeCardEdit
  .sidebar-removed {
    display: none;
  }
  */
  .show-sidebar-xxlarge .sidebar-hidden.responsive {
    display: block !important;
  }

  .hide-profile-button {
    position:fixed;
    height: 100%;
    background-color: #9a9a9a;
    padding-top: 7px;
    padding-left: 4px;
    width:25px;
    color:black;
    cursor: pointer;
  }
  .show-profile-button {
    width: 10px;
    right: 20px;
    top: 10px;
    position: absolute;
    color: black;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardSidebar.vue